export default "__VITE_ASSET__c0115d82__"